import { Controller } from "@hotwired/stimulus"

// Caja de respuesta que empieza colapsada (una línea) y se expande al clicar/enfocar.
export default class extends Controller {
  expand() {
    this.element.classList.add("is-expanded")
  }
}
